import { fromJS } from 'immutable';

export const refColumns = fromJS([
  'id',
  'author',
  'year',
  'citation',
]);

export const refSort = fromJS([
  { id: 'author', asc: true },
]);

export const minColumns = fromJS([]);
